import { Fetch } from 'lib';
import type { Brand, BrandFileInfoSummary } from 'types';

type RequestResponses = Brand;

type RequestParameters = {};

type RequestBody = StrictOmit<Brand, 'id' | 'pictures' | 'videos'> &
  Record<'pictures' | 'videos', BrandFileInfoSummary[]>;

const createBrand = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminBrand/createBrand',
    method: 'POST',
    body,
  });

export { createBrand };
